import { render, staticRenderFns } from "./LandingPageWhatInsuranceCoverComponent.vue?vue&type=template&id=7508554b&scoped=true&"
import script from "./LandingPageWhatInsuranceCoverComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPageWhatInsuranceCoverComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageWhatInsuranceCoverComponent.vue?vue&type=style&index=0&id=7508554b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7508554b",
  null
  
)

export default component.exports